import React from 'react';
import classes from './landingCooperation.module.css';
const CallToAction = ({ text }) => {
  return (
    <section className={classes['cta-section']}>
      <div className={classes['cta-small-container']}>
        <div className={classes['cta-content']}>
          <div className={classes['cta-row']}>
            <div className={classes['cta-details']}>
              <h2>ابدأ الآن واشترك مع فهيم</h2>
              <p>{text}</p>
              <button
                onClick={() => {
                  document
                    .getElementById('register-form')
                    .scrollIntoView({ behavior: 'smooth' });
                }}
                className={classes['cta-button']}
              >
                اشترك الآن
              </button>
            </div>
            <div className={classes['cta-image']}></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
